import { FC, memo, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { useColumnSizing } from '../columnSizing/useColumnSizing';
import { useTableStoreValue } from '../TableContext';
import { ColGroup, TableHead } from '../common';

export interface TableMainProps extends PropsWithChildren {
  className?: string;
}

export const TableShell: FC<TableMainProps> = memo((props) => {
  const { className, children } = props;
  const [id] = useTableStoreValue('id');
  const [table] = useTableStoreValue('table');
  const [sticky] = useTableStoreValue('sticky');
  const [hideHeader] = useTableStoreValue('hideHeader');
  const [hideLeftStickyShadow] = useTableStoreValue('hideLeftStickyShadow');
  const [hideRightStickyShadow] = useTableStoreValue('hideRightStickyShadow');
  const [, setTbody] = useTableStoreValue('tbody');

  const classNames = [];

  if (hideLeftStickyShadow) {
    classNames.push('hide-left-shadow');
  }

  if (hideRightStickyShadow) {
    classNames.push('hide-right-shadow');
  }

  const { colgroupRef } = useColumnSizing();

  return (
    <StyledTable id={sticky ? undefined : id} className={className}>
      <ColGroup ref={colgroupRef} cols={table.getHeaderGroups()[0]} />
      {!sticky && !hideHeader && <TableHead />}
      <tbody ref={setTbody} className={classNames.join(' ')}>
        {children}
      </tbody>
    </StyledTable>
  );
});

export const StyledTable = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;

  .column-sizing-enabled & {
    width: fit-content;
  }

  colgroup col {
    min-width: 50px;
  }

  .hide-left-shadow > tr > .sticky-left,
  .hide-right-shadow > tr > .sticky-right {
    &:after {
      display: none;
    }
  }

  .hide-box-shadow {
    box-shadow: none;
  }

  tr.is-dragged {
    opacity: 0.3;
  }
`;
